import withErrorHandler from "component/design-system/withErrorHandler";
import { ILandingPagePageDetails, IMakeModelTiers } from "interfaces/cms/static-content";
import dynamic from "next/dynamic";
import { groupArray } from "../../util/helper/groupArray";
const CategoryMakesModel = dynamic(() => import(/* webpackChunkName: "category-makes-model" */"component/landing-page/CategoryMakesModel"));

interface IOBDCategoryMakeModel {
  makeModelTiers: IMakeModelTiers,
  pageDetails: ILandingPagePageDetails,
}

function OBDCategoryMakeModel(props: IOBDCategoryMakeModel) {
  const {
    makeModelTiers: { heading, content }, pageDetails,
  } = props;
  const data = groupArray(content, (item: any) => item.displayableMake, "models");
  const category = pageDetails?.tier3 || pageDetails?.tier2;

  if (!category || data.length === 0) {
    return null;
  }
  const obdCode = pageDetails?.obdCode?.substring(0, 5);

  const transformData = data
    .map((_: any) => ({
      ..._,
      displayableMake: _.key,
      make: _.key,

      models: [..._.models
        .sort((a: any) => !a.popular)
        .map((model: any) => ({
          ...model,
          category,
          url: model.makeModelTierUrl,
        }))],
    }))
    .sort((a: any, b: any) => b.models.length - a.models.length);

  return (
    <CategoryMakesModel
      {...{
        heading: `${heading} Displaying ${obdCode}`,
        data: transformData,
      }}
    />
  );
}

export default withErrorHandler(OBDCategoryMakeModel);
